module.exports = __webpack_public_path__ + "img/add.19a8fe43.png";